"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
const _excluded = ["porintId", "bg", "list"],
  _excluded2 = ["itemList"],
  _excluded3 = ["icon", "linkText", "linkHref"],
  _excluded4 = ["porintId", "bg"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TmpCompliance
 * @author garythtu
 * @created 2025-12-10 07:14:13
 */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTmpComplianceData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const handledList = list === null || list === void 0 ? void 0 : list.map((activityItem, listIndex) => {
    const _ref2 = activityItem || {},
      _ref2$itemList = _ref2.itemList,
      itemList = _ref2$itemList === void 0 ? [] : _ref2$itemList,
      other = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
    const handledItemList = itemList === null || itemList === void 0 ? void 0 : itemList.map((activityItem, itemIndex) => {
      const _ref3 = activityItem || {},
        _ref3$icon = _ref3.icon,
        icon = _ref3$icon === void 0 ? '' : _ref3$icon,
        linkText = _ref3.linkText,
        _ref3$linkHref = _ref3.linkHref,
        linkHref = _ref3$linkHref === void 0 ? '' : _ref3$linkHref,
        other = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
      const linkExtendProps = {
        'report-event': 'click_Compliance_link',
        'report-ext1': itemIndex,
        'report-ext2': linkHref,
        target: '_blank'
      };
      let linkElement = null;
      if (linkText) {
        linkElement = /*#__PURE__*/React.createElement(_tpmProductIntl.Link, _objectSpread({
          key: `link-${listIndex}-${itemIndex}`,
          href: linkHref,
          icon: true
        }, linkExtendProps), linkText);
      }
      return _objectSpread({
        icon: (0, _componentUtils.doComponentsUploadEvent)(icon).url,
        link: linkElement
      }, other);
    });
    return _objectSpread({
      itemList: handledItemList
    }, other);
  });
  return _objectSpread({
    porintId,
    bg,
    list: handledList
  }, other);
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTmpComplianceD = formatTmpComplianceData(data, {
        domains
      }),
      porintId = _formatTmpComplianceD.porintId,
      bg = _formatTmpComplianceD.bg,
      other = (0, _objectWithoutProperties2.default)(_formatTmpComplianceD, _excluded4);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TmpCompliance`
    }, (0, _reportUtil.reportShow)(['show_newUI_TmpCompliance', componentKey, porintId || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      bg: bg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Compliance, other)));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}